export const LEVEL_NAMES: Record<number, string> = {0: "BASIC", 1: "REGULAR", 2: "VERIFIED"};

export const LEVEL_BADGE_VARIANT: Record<number, "neutral" | "info" | "success"> = {
  0: "neutral",
  1: "info",
  2: "success",
};

export const formatCents = (cents: string) => {
  const num = Number(cents) / 100;
  return new Intl.NumberFormat("en-US", {style: "currency", currency: "USD"}).format(num);
};

export const formatDate = (iso: string): string => {
  if (!iso) return "—";
  return new Intl.DateTimeFormat("es-CL", {dateStyle: "short", timeStyle: "short"}).format(new Date(iso));
};
